export const FHIR_SEARCH_PAGE_SIZE = "1000";

// Collection registry names — single source of truth.
export const ACTIVITY_DEFINITION_COLLECTION_NAME = "activityDefinition";
export const ALLERGY_INTOLERANCE_COLLECTION_NAME = "allergyIntolerance";
export const APPOINTMENT_COLLECTION_NAME = "appointment";
export const AVAILABILITY_BLOCK_COLLECTION_NAME = "availability-block";
export const BASIC_COLLECTION_NAME = "basic";
export const BOOKED_SLOT_COLLECTION_NAME = "booked-slot";
export const CARE_PLAN_COLLECTION_NAME = "carePlan";
export const CLINICAL_IMPRESSION_COLLECTION_NAME = "clinicalImpression";
export const COMMUNICATION_COLLECTION_NAME = "communication";
export const CONDITION_COLLECTION_NAME = "condition";
export const DEVICE_COLLECTION_NAME = "device";
export const DEVICE_DEFINITION_COLLECTION_NAME = "deviceDefinition";
export const DOCUMENT_REFERENCE_COLLECTION_NAME = "documentReference";
export const ENCOUNTER_COLLECTION_NAME = "encounter";
export const EPISODE_OF_CARE_COLLECTION_NAME = "episodeOfCare";
export const FLAG_COLLECTION_NAME = "flag";
export const GOAL_COLLECTION_NAME = "goal";
export const LOCATION_COLLECTION_NAME = "location";
export const MEDICATION_STATEMENT_COLLECTION_NAME = "medicationStatement";
export const OBSERVATION_COLLECTION_NAME = "observation";
export const PATIENT_COLLECTION_NAME = "patient";
export const PLAN_DEFINITION_COLLECTION_NAME = "planDefinition";
export const PRACTITIONER_COLLECTION_NAME = "practitioner";
export const PROCEDURE_COLLECTION_NAME = "procedure";
export const QUESTIONNAIRE_COLLECTION_NAME = "questionnaire";
export const QUESTIONNAIRE_RESPONSE_COLLECTION_NAME = "questionnaireResponse";
export const REQUEST_GROUP_COLLECTION_NAME = "requestGroup";
export const SCHEDULE_COLLECTION_NAME = "schedule";
export const SERVICE_REQUEST_COLLECTION_NAME = "serviceRequest";
export const SLOT_COLLECTION_NAME = "slot";
export const TASK_COLLECTION_NAME = "task";

export const RELATED_PERSON_COLLECTION_NAME = "relatedPerson";
